<template>
  <div>
    <el-select
      :value="value"
      size="small"
      filterable
      clearable
      remote
      @change="handleChange"
      :loading="loading"
      :remote-method="requestData"
      placeholder="搜索并选择"
      style="width: 100%"
      :popper-append-to-body="false"
    >
      <el-option
        v-for="item in lists"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import { reportUserList } from '../../service/getData'

export default {
  props: {
    value: '',
  },
  data() {
    return {
      lists: [],
      loading: false,
    }
  },
  created() {
    if (this.value) {
      this.requestData('', this.value)
    }
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },

    async requestData(query, defaultValue = 0) {
      let data = {
        name: query,
        size: 20,
        id: defaultValue,
      }
      let res = await reportUserList(data)
      this.loading = false
      this.lists = res.data.list
    },
  },
}
</script>
<style>
.select-err .el-input__inner {
  border-color: #f56c6c;
}
</style>